/**
 * @deprecated use tooltip direct
 */
import React from 'react';
import Tooltip from '../tooltip';
import { TooltipContext, defaultValue } from '../tooltip/tooltip-context';
export const Popover = (props) => {
    return (React.createElement(TooltipContext.Provider, { value: Object.assign(Object.assign({}, defaultValue), { showArrow: false }) },
        React.createElement(Tooltip, { content: props.content, offset: 0, placement: props.placement }, props.children)));
};
